















import './KisweCopyButton.scss'
import { defineComponent, toRef, computed, ref } from '@vue/composition-api'
import  KisweButton from '@/modules/kisweui/components/KisweButton/KisweButton'
import KisweIcon from '@/modules/kisweui/components/KisweIcon'
import { useShapes, useSizes, useThemes } from '../../compositions'
import { KisweShape, KisweSize, KisweTheme } from '../../types'

export default defineComponent({
  name: 'KisweCopyButton',
  components: {
    KisweButton,
    KisweIcon
  },
  props: {
    value: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: 'copy-filled'
    },
    copiedIcon: {
      type: String,
      required: false,
      default: 'check'
    },
    hasCopiedBackground: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    ...useThemes({ theme: KisweTheme.Tertiary }).props,
    ...useShapes({ shape: KisweShape.Square }).props,
    ...useSizes({ size: KisweSize.Small }).props
  },
  setup (props) {
    const buttonIcon = ref(props.icon)
    const stringToCopy = toRef(props, 'value')
    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(stringToCopy.value)
        buttonIcon.value = props.copiedIcon
        setTimeout( () => {
          buttonIcon.value = props.icon
        }, 1000)
      } catch (error) {
        console.error(`Failed to copy value "${ stringToCopy.value }" to clipboard.`, error)
      }
    }
    return {
      buttonIcon,
      copyToClipboard,
      isCopied: computed(() => buttonIcon.value === props.copiedIcon)
    }
  }
})
